import React, { FC, ReactElement } from "react";
import {Typography} from "@mui/material";
import "./Timeline.css"


interface TimeLineItems{
    data:any;
}

interface TimeLineProps {
    title?: string;
    TimeLineData: any;
}


//https://www.florin-pop.com/blog/2019/04/how-to-create-a-timeline-with-react/
const TimeLine = ({title, TimeLineData}: TimeLineProps): ReactElement => {
    const TimelineItem = ({ data }: TimeLineItems) => (
        <div className="timeline-item">
            <div className="timeline-item-content">
                {data.category && (<span className="tag" style={{ background: data.category.color }}>
                {data.category.tag}</span>)}
                <time>{data.date}</time>
                <p>{data.text}</p>
                {data.info && (<div className="timeline-item-info">{data.info}</div>)}
                {data.link && (
                    <a
                        href={data.link.url}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {data.link.text}
                    </a>
                )}
                <span className="circle" />
            </div>
        </div>
    );
    
    return (
        <div>
            <Typography variant="h4" style={{textAlign: "center"}}>{title}</Typography>
            {TimeLineData.length > 0 && (
                <div className="timeline-container">
                    {TimeLineData.map((data: any, idx: React.Key | null | undefined) => (
                        <TimelineItem data={data} key={idx} />
                    ))}
                </div>
            )}
        </div>
    )
}
export default TimeLine

